import { render, staticRenderFns } from "./ResultsGradient.vue?vue&type=template&id=3d9201e0&"
import script from "./ResultsGradient.vue?vue&type=script&lang=js&"
export * from "./ResultsGradient.vue?vue&type=script&lang=js&"
import style0 from "./ResultsGradient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports